module.exports = __webpack_public_path__ + "static/index/img/account_login.cc398f2b.png";